(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
(window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['mousemove'];
